import {
  ListaDeVistasSchema,
  VistaGuardadaSchema,
  type EdicionDeVista,
  type NuevaVista,
  type PantallaDeVista,
} from '@cnc/contracts';
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {json, pedir} from './cliente';

const clave = (pantalla: PantallaDeVista) => ['vistas', pantalla] as const;

// Las vistas guardadas de la persona en una pantalla.
export function useVistas(pantalla: PantallaDeVista) {
  return useQuery({
    queryKey: clave(pantalla),
    queryFn: () => pedir(`cuenta/vistas?pantalla=${pantalla}`, ListaDeVistasSchema),
    staleTime: 5 * 60_000,
  });
}

export function useCrearVista(pantalla: PantallaDeVista) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (datos: Omit<NuevaVista, 'pantalla'>) =>
      pedir('cuenta/vistas', VistaGuardadaSchema, json('POST', {...datos, pantalla})),
    onSuccess: () => cliente.invalidateQueries({queryKey: clave(pantalla)}),
  });
}

export function useEditarVista(pantalla: PantallaDeVista) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: ({id, cambios}: {id: number; cambios: EdicionDeVista}) =>
      pedir(`cuenta/vistas/${id}`, VistaGuardadaSchema, json('PATCH', cambios)),
    onSuccess: () => cliente.invalidateQueries({queryKey: clave(pantalla)}),
  });
}

export function useBorrarVista(pantalla: PantallaDeVista) {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => pedir(`cuenta/vistas/${id}`, ListaDeVistasSchema, json('DELETE')),
    onSuccess: () => cliente.invalidateQueries({queryKey: clave(pantalla)}),
  });
}
